module.exports = __webpack_public_path__ + "img/ringbank@2x.60041bb.jpg";